// extracted by mini-css-extract-plugin
export default {"profile":"styles_profile__qgBwP","hour":"styles_hour__Kq68v","container":"styles_container__dbCk7","containerImg":"styles_containerImg__TprXd","sidebar":"styles_sidebar__QWnFE"};